import { useMemo } from 'react';
import type { Store } from '../services/types';
import { useCurrentUrl } from './useCurrentUrl';

type UseExcludeOnPatternsProps = {
  store?: Store;
};

export const useExcludeOnPatterns = ({ store }: UseExcludeOnPatternsProps) => {
  const currentUrl = useCurrentUrl();

  const isExcludedOnPatterns = useMemo(() => {
    const excludePatterns =
      store?.config?.config?.answerConfig?.excludeOnPatterns;

    if (!excludePatterns?.length) {
      return false;
    }

    return excludePatterns.some((pattern) => {
      try {
        return new RegExp(pattern).test(currentUrl);
      } catch (error) {
        console.warn(`Invalid regex pattern: ${pattern}`, error);
        return false;
      }
    });
  }, [currentUrl, store?.config?.config?.answerConfig?.excludeOnPatterns]);

  return {
    isExcludedOnPatterns,
    currentUrl,
  };
};
